import { makeObservable, observable, computed, action } from 'mobx';

class ShortlistStore {
    shortlistedUnits = new Set();
    isPopupOpen = false;
    
    constructor() {
        makeObservable(this, {
            shortlistedUnits: observable,
            isPopupOpen: observable,
            shortlistedCount: computed,
            shortlistedUnitsArray: computed,
            addToShortlist: action,
            removeFromShortlist: action,
            toggleShortlist: action,
            clearShortlist: action,
            openPopup: action,
            closePopup: action,
        });
        
        // Load from localStorage on initialization
        this.loadFromLocalStorage();
    }
    
    get shortlistedCount() {
        return this.shortlistedUnits.size;
    }
    
    get shortlistedUnitsArray() {
        return [...this.shortlistedUnits];
    }
    
    addToShortlist(unitId) {
        this.shortlistedUnits.add(unitId);
        this.saveToLocalStorage();
    }
    
    removeFromShortlist(unitId) {
        this.shortlistedUnits.delete(unitId);
        this.saveToLocalStorage();
    }
    
    toggleShortlist(unitId) {
        if (this.shortlistedUnits.has(unitId)) {
            this.removeFromShortlist(unitId);
        } else {
            this.addToShortlist(unitId);
        }
    }
    
    isShortlisted(unitId) {
        return this.shortlistedUnits.has(unitId);
    }
    
    clearShortlist() {
        this.shortlistedUnits.clear();
        this.saveToLocalStorage();
    }
    
    openPopup() {
        this.isPopupOpen = true;
    }
    
    closePopup() {
        this.isPopupOpen = false;
    }
    
    saveToLocalStorage() {
        try {
            localStorage.setItem('shortlistedUnits', JSON.stringify(this.shortlistedUnitsArray));
        } catch (error) {
            console.error('Failed to save shortlist to localStorage:', error);
        }
    }
    
    loadFromLocalStorage() {
        try {
            const saved = localStorage.getItem('shortlistedUnits');
            if (saved) {
                const unitIds = JSON.parse(saved);
                this.shortlistedUnits = new Set(unitIds);
            }
        } catch (error) {
            console.error('Failed to load shortlist from localStorage:', error);
        }
    }
}

export default ShortlistStore;
